import { site } from '@/content/et/site';
import { Button } from '@/components/ui/Button';
import styles from './NotFoundPage.module.css';

export function NotFoundPage() {
  return (
    <main id="main" className={styles.page}>
      <div className="container">
        <p className={styles.code}>404</p>
        <h1 className={styles.title}>{site.notFound.title}</h1>
        <p className={styles.lead}>{site.notFound.lead}</p>
        <Button to="/">{site.notFound.home}</Button>
      </div>
    </main>
  );
}
